// extracted by mini-css-extract-plugin
export default {"dress":"Dress_dress__3vcSc","images":"Dress_images__TK4Oo","quote":"Dress_quote__18dOf"};